import {
  Box,
  Container,
  Stack,
  StackOwnProps,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import COLORS from "../../constants/colors";

interface Props extends StackOwnProps {
  imageSvg?: React.ReactNode;
  title: string;
  description?: string;
  buttons: React.ReactNode[];
  content?: React.ReactNode;
  children?: React.ReactNode;
}

const MessageBox: React.FC<Props> = (props) => {
  const { imageSvg, title, description, buttons, content, children } = props;
  const startRef = useRef(null as any);

  useEffect(() => {
    if (startRef.current) {
      startRef.current.focus(); // Set focus to the target element
    }
  }, []);

  return (
    <Container>
      <Stack
        justifyContent="center"
        display="flex"
        alignItems="center"
        pt={{ xs: "40px" }}
        pb="75px"
        {...props}
        title="" // empty string avoids tooltip
      >
        <Stack
          padding={{ xs: "4px", md: "48px" }}
          bgcolor={{ md: COLORS.TRUE_WHITE[100], xs: "none" }}
          borderRadius="12px"
        >
          <Stack
            bgcolor={COLORS.BRIGHT_BLUE[10]}
            borderRadius="12px"
            padding={{ xs: "24px", md: "48px" }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap="32px"
          >
            {imageSvg}
            <Typography
              tabIndex={-1}
              ref={startRef}
              aria-live="assertive"
              role="main"
              maxWidth="556px"
              variant="h3"
              color={COLORS.NORMAL[100]}
              textAlign="center"
            >
              {title}
            </Typography>
            {description && (
              <Typography
                maxWidth="420px"
                variant="lead"
                color={COLORS.NORMAL[100]}
                textAlign="center"
              >
                {description}
              </Typography>
            )}
            {content}
            <Box display="flex" flexDirection="column" gap="24px">
              {buttons}
            </Box>
            {children}
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};

export default MessageBox;
